import { ServiceResponse } from '@sdbn/appclient';
import { AttachDetachDetails } from '../model/attach-detach-details';
import { HttpService } from '@sdbn/appclient';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TruckDetails } from '../model/visit-details';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransportAttachDetachService {

  constructor(private httpClient: HttpService) { }

  getAttachDetachDetails(transportId: number): Observable<AttachDetachDetails> {
    return this.httpClient.postWithContext<AttachDetachDetails>(environment.attachDetachEndpoint + '/details', { id: transportId });
  }

  getCurrentVisits(): Observable<TruckDetails[]> {
    return this.httpClient.postWithContext<TruckDetails[]>(environment.attachDetachEndpoint + '/current-visits', {});
  }

  getTargetsForTrailerSwap(): Observable<TruckDetails[]> {
    return this.httpClient.postWithContext<TruckDetails[]>(environment.attachDetachEndpoint + '/targets-for-trailer-swap', {});
  }

  save(details: AttachDetachDetails): Observable<ServiceResponse> {
    return this.httpClient.postWithContext<ServiceResponse>(environment.attachDetachEndpoint + '/save', details);
  }
}
